module.exports = __webpack_public_path__ + "img/img_certification_mark_02.37b673d.png";